export default __webpack_public_path__ + "static/media/19.f44900ae.svg";